import { useParams } from "react-router-dom";
import { Briefcase, ScrollText } from "lucide-react";
import {
  DocumentSection,
  type TipoOption,
} from "@/components/documentos/document-section";

// Mejora "Docs por familia" (changelog cliente): la página se divide en
// dos bloques. La IA distingue cada uno al generar la propuesta:
// - "Bases de la convocatoria" → qué requisitos hay que cumplir.
// - "Documentos de apoyo" → con qué credenciales se posiciona la
//   empresa.

const BASES_TIPOS: TipoOption[] = [
  { value: "PLIEGO_TECNICO", label: "Pliego técnico" },
  { value: "PLIEGO_ADMINISTRATIVO", label: "Pliego administrativo" },
  { value: "ANEXO", label: "Anexo / documento del organismo" },
];

const APOYO_TIPOS: TipoOption[] = [
  { value: "MEMORIA_EMPRESA", label: "Memoria de empresa" },
  { value: "CASOS_DE_EXITO", label: "Caso de éxito" },
  { value: "PROYECTO_REFERENCIA", label: "Proyecto de referencia" },
  { value: "PROPUESTA_ANTERIOR", label: "Propuesta anterior" },
  { value: "EVALUACION_ANTERIOR", label: "Evaluación recibida" },
  { value: "CERTIFICACIONES", label: "Certificación / acreditación" },
  { value: "OTRO", label: "Otro documento de apoyo" },
];

export default function DocumentosPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;

  return (
    <div className="space-y-8">
      <DocumentSection
        licitacionId={id}
        familia="bases"
        title="Bases de la convocatoria"
        description="Pliegos y anexos publicados por el organismo. La IA los usa como fuente única de los requisitos que debe cumplir la propuesta."
        icon={ScrollText}
        tipoOptions={BASES_TIPOS}
        defaultTipo="PLIEGO_TECNICO"
      />

      <DocumentSection
        licitacionId={id}
        familia="apoyo"
        title="Documentos de apoyo"
        description="Memoria de empresa, evaluaciones pasadas, casos de éxito, certificaciones… La IA los usa para posicionar a la empresa, no como fuente de requisitos."
        icon={Briefcase}
        tipoOptions={APOYO_TIPOS}
        defaultTipo="MEMORIA_EMPRESA"
      />
    </div>
  );
}
